import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const LETTERS = "AROUND THE WORLD".split("");

export default function Preloader({ onReveal }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setShow(false);
      onReveal();
    }, 1000);
    return () => clearTimeout(t);
  }, [onReveal]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="preloader"
          data-testid="preloader"
          className="fixed inset-0 z-[120] bg-ink text-ivory flex flex-col items-center justify-center overflow-hidden"
          exit={{ y: "-100%", transition: { duration: 1, ease: [0.76, 0, 0.24, 1] } }}
        >
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.16),transparent_60%)]" />
          <motion.img
            src="/brand/logo-seal.png"
            alt=""
            initial={{ opacity: 0, scale: 0.6, rotate: -90 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="relative w-24 h-24 md:w-32 md:h-32 mb-8 drop-shadow-[0_0_40px_rgba(212,175,55,0.45)]"
          />
          <div style={{ perspective: 800 }} className="relative flex font-serif uppercase text-2xl sm:text-4xl md:text-6xl tracking-[0.18em]">
            {LETTERS.map((ch, i) => (
              <motion.span
                key={i}
                initial={{ opacity: 0, rotateX: 95, y: 40 }}
                animate={{ opacity: 1, rotateX: 0, y: 0 }}
                transition={{ delay: 0.3 + i * 0.035, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                style={{ display: "inline-block", transformStyle: "preserve-3d", transformOrigin: "bottom" }}
                className={ch === " " ? "w-[0.45em]" : ch === "W" ? "text-gold-light italic" : ""}
              >
                {ch}
              </motion.span>
            ))}
          </div>
          <motion.p
            initial={{ opacity: 0, letterSpacing: "0.2em" }}
            animate={{ opacity: 1, letterSpacing: "0.5em" }}
            transition={{ delay: 0.9, duration: 0.7 }}
            className="relative mt-7 text-[9px] md:text-[11px] uppercase text-gold-light"
          >
            By Dewan Ali · A Creation of Around The World Ltd
          </motion.p>
          <motion.div
            className="absolute bottom-16 h-px bg-gold-light"
            initial={{ width: 0 }}
            animate={{ width: "42vw" }}
            transition={{ duration: 1.6, ease: "easeInOut" }}
          />
          <motion.div
            className="absolute inset-x-0 bottom-0 h-1 bg-gold-light origin-left"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.7, ease: "easeInOut" }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
